<script>
    import { onMount, afterUpdate } from 'svelte';
    import { navigateTo } from 'svelte-router-spa';
    import _ from 'lodash';
    import dayjs from 'dayjs';
    import advancedFormat from 'dayjs/plugin/advancedFormat'
    dayjs.extend(advancedFormat)

    import Loading from '@general/loading.svelte';
    import { getData, deleteData, updateData } from '@general/myAxios';

    let timelines = [], src = '', highlight_tl = '', isLoading = false

    onMount(() => {
        isLoading = true;
        getData('/list').then(result => {
            timelines = result.data;
            highlight_tl = timelines.find(tl=>tl.is_highlighted == true).uuid;
            isLoading = false;
        })
    })

    let getYTPic = (url) => {
        // console.log('@yt ', url)
        let vid = '', urlsplt = url.split('/');
        vid = url.includes('v=') ? new URL(url).searchParams.get('v') : urlsplt[urlsplt.length - 1];
        return `https://img.youtube.com/vi/${vid}/hqdefault.jpg`;
    }

    let getPic = (picname) => {
        //get images
        let tlImages = _.flatten(timelines.map(t => t.timelineimages));
        // console.log('@ picname ', tlImages.find(tl => tl.name == picname)?.image ?? '')
        return tlImages.find(tl => tl.name == picname)?.image ?? ''
    }


    let deleteTimeline = uuid => {
        if (confirm('Delete selected timeline?')) {
            // let tl = timelines.find(tl => tl.uuid == uuid)
            // tl = {...tl, isDeleting: true}
            // timelines = {...timelines, ...tl}

            deleteData('/delete/' + uuid).then(res => {
                getData('/list').then(result => {
                    timelines = result.data;
                })
            });
        }
    }

    let editTimeline = uuid => {
        navigateTo(`form/edit/${uuid}`)
    }


</script>

<style>
    img {
        /* float: left; */
        width: 200px;
        height: 200px;
        object-fit: cover;
    }
</style>

{#if isLoading}
<Loading />
{:else}
{#each timelines as timeline}
<div class="row">
    <div class="col-md-3" style="flex-direction: row; display: flex;">
        <label style="margin-top: 15px; width: 100px;">
            <center>
                <input type=radio bind:group={highlight_tl} value={timeline.uuid} on:change={()=>{
                    updateData('/update/highlighted/'+highlight_tl)
                }}><br />
                {timeline.title}<br />
                {#if timeline.uuid == highlight_tl}
                    <i>(highlighted)</i>
                {/if}
            </center>
        </label>
        &nbsp;
        <div class="btn-group" role="group" aria-label="Basic example"
            style="height: 40px; margin-top: 10px; margin-left: 10px;">
            <button class="btn btn-dark" on:click={editTimeline(timeline.uuid)}>
                Edit
            </button>

            <button class="btn btn-danger" on:click={deleteTimeline(timeline.uuid)} disable={timeline.isDelete}>
                {#if timeline.isDelete}
                    Deleting...
                {:else}
                    Delete
                {/if}
            </button>
        </div>

    </div> 

    <div class="col-md-9">
        <div style="display: flex; flex-direction: row; overflow-y: scroll;">
            {#each timeline.data as tl}
            <div class="card" style="min-width: 350px; width: 350px; margin-top: 7px;">
                <div class='card-header' style="height: 200px; overflow-y: scroll;">
                    {#if tl.is_title_page}
                        <small class="badge badge-success badge-pill">Set as title page</small>
                        <br/>
                    {/if}
                    <b>Headline:</b> {tl.text.headline}<br />
                    <b>Date:</b> {dayjs(`${tl.start_date.year}-${tl.start_date.month}-${tl.start_date.day}`).format('Do MMMM,YYYY')}<br />
                    <b>Text:</b> {tl.text.text}<br />
                </div>
                <div class='card-body'>
                    <img src={tl.media.type=='img' ? getPic(tl.media.url) : getYTPic(tl.media.url ) }
                        alt="{tl.text.headline}" /> <br />
                    <i>Caption: {tl.media.caption}</i><br />
                    {#if tl.media.type == 'img' }
                    <small>Photo Credit: {tl.media.credit}</small>
                    {/if}
                </div>
            </div>
            &nbsp;
            {/each}
        </div>
    </div>

</div>
<br />
{/each}
{/if}